import { makeAutoObservable, runInAction } from "mobx";
import Subjects from "../../models/subjects";
import { StudentService } from "../../services/student-service";
import { message } from "antd";
import StudentTaskStore from "./student-task-item";
import { IStudentTask } from "../../models/student";
import { CompletedTicketService } from "../../services/completed-ticket-service";

export default class StudentTicketStore {

     tasks: StudentTaskStore[];
     ticketId: number | undefined;
     completedTicketId: number | undefined;
     pointsSum: number | undefined;
     loading: boolean;
     subject: Subjects;
     studentName: string;
     studentService: StudentService;
     completedTaskService: CompletedTicketService;

     constructor(subject: Subjects) {

          this.tasks = [];
          this.loading = false;
          this.subject = subject;
          this.studentName = '';
          this.studentService = new StudentService(subject);
          this.completedTaskService = new CompletedTicketService();

          makeAutoObservable(this);
     }

     loadTicket(studentId: string | undefined, ticketId: string | undefined) {

          if (!studentId) {
               console.log("studentId is undefined");
               return;
          }

          this.loading = true;

          try {

               if (ticketId) {

                    this.studentService.loadTicketById(studentId, ticketId, this.subject, data => {
                         this.ticketId = data['ticketId'];
                         this.studentName = data['studentName'];
                         this.completedTicketId = data['completedTicketId'];
                         this.tasks = (data['content'] as IStudentTask[]).map((item) => new StudentTaskStore(item));
                    });

               } else {

                    this.studentService.loadCurrentTicket(studentId, this.subject, data => {
                         this.ticketId = data['ticketId'];
                         this.studentName = data['studentName'];
                         this.completedTicketId = data['completedTicketId'];
                         this.tasks = (data['content'] as IStudentTask[]).map((item) => new StudentTaskStore(item));
                    });
               }

          } catch (error) {
               runInAction(() => {
                    this.loading = false;
                    message.error(`Ошибка при загрузке варианта: ${error}`);
               });
          }
     }

     saveAll() {

          const body = this.tasks.map(t => t.data);

          this.completedTaskService.saveTasks(body, () => {
               message.success("Успешно сохранено!");
               this.tasks.forEach(t => t.isSaved = true);
          });
     }

     finish() {

          const body = this.tasks.map(t => t.data);

          this.completedTaskService.saveTasks(body, () => {

               this.tasks.forEach(t => t.isSaved = true);

               if (!this.completedTicketId) {
                    console.log("completedTicketId is undefined");
                    return;
               }

               this.completedTaskService.finished(this.completedTicketId, data => {

                    message.success("Проверка успешно завершена");
                    this.pointsSum = data['pointsSum'];
               });
          });
     }
}